import { render, staticRenderFns } from "./main-announcement.vue?vue&type=template&id=01087202&scoped=true&"
import script from "./main-announcement.vue?vue&type=script&lang=js&"
export * from "./main-announcement.vue?vue&type=script&lang=js&"
import style0 from "./main-announcement.vue?vue&type=style&index=0&id=01087202&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01087202",
  null
  
)

export default component.exports